import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import confetti from "canvas-confetti";

const animals = ["🐅", "🦒","🐻", "🦅", "🦌"];

function App() {
  const [step, setStep] = useState(0); // 0 = mensaje, 1 = regalo

  useEffect(() => {
    const timer = setTimeout(() => {
      setStep(1);
      confetti({
        particleCount: 150,
        spread: 100,
        origin: { y: 0.6 },
      });
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-pink-100 to-pink-300">
      <AnimatePresence>
        {step === 0 && (
          <motion.div
            key="message"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            transition={{ duration: 1 }}
            className="flex items-center justify-center min-h-screen px-4"
          >
            <div className="text-center text-3xl font-semibold text-rose-600">
              Por nuestro <strong>primer año</strong> juntos 💖
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {step === 1 && (
          <motion.div
            key="gift"
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.5 }}
            transition={{ duration: 1 }}
            className="flex flex-col items-center justify-center min-h-screen px-4"
          >
            <div className="bg-white p-8 rounded-xl shadow-xl max-w-md w-full text-center">
              <h1 className="text-2xl font-bold mb-4">🎁 ¡Feliz año!</h1>
              <p className="mb-6 text-lg">
                Vale por <strong>2 entradas</strong> al <br />
                <strong>Parque de la Naturaleza de Cabárceno</strong>
              </p>

              <div className="flex justify-center space-x-4 mt-4 select-none" aria-label="animales">
                {animals.map((animal, i) => (
                  <motion.span
                    key={i}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 1 + i * 0.3, duration: 0.5 }}
                    style={{ fontSize: "2.5rem" }}
                  >
                    {animal}
                  </motion.span>
                ))}
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;
